import * as ActionCable from "@rails/actioncable"
import { type Cable } from "@rails/actioncable"
import { defineStore } from "pinia"

const appEnv = useRuntimeConfig().public.appEnv

export interface IActionCableState {
  actioncable?: Cable & any
}

export const useActionCableStore = defineStore("actionCableStore", {
  state: (): IActionCableState => ({
    actioncable: null,
  }),

  actions: {
    init(authToken: string) {
      if (!this.actioncable) {
        this.actioncable = ActionCable.createConsumer(`${useRuntimeConfig().public.wsBase}/${authToken}`)

        if (appEnv !== "production") {
          console.log("[ActionCable] Store init called... with auth token", authToken)
        }
      }
    },

    disconnect() {
      this.actioncable?.disconnect()
    },

    destroy() {
      this.disconnect()
      if (this.actioncable) {
        this.actioncable = null
      }
    },
  },
})
